/**
 * SeriesBanner — quiet editorial identifier line at the top of every read.
 * Renders as a crimson uppercase kicker (the read type) with a muted mono date
 * to the right, over a hairline rule. (Reworked from the filled navy banner
 * strip of the v10 "Dummies" grammar — it now reads as an editorial eyebrow.)
 */

export default function SeriesBanner({ type, dateLabel }) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "baseline",
        justifyContent: "space-between",
        paddingBottom: 10,
        borderBottom: "1px solid var(--ppr-color-border-default)",
      }}
      data-component="SeriesBanner"
    >
      <span
        style={{
          fontFamily: "var(--ppr-typography-font-family-ui)",
          fontSize: "11px",
          letterSpacing: "0.18em",
          textTransform: "uppercase",
          color: "var(--ppr-color-accent-coral)",
        }}
      >
        {type}
      </span>
      {dateLabel ? (
        <span
          style={{
            color: "var(--ppr-color-text-muted)",
            fontFamily: "var(--ppr-typography-font-family-mono)",
            fontSize: "11px",
            letterSpacing: "0.04em",
          }}
        >
          {dateLabel}
        </span>
      ) : null}
    </div>
  );
}
